import { useQueryClient, useMutation } from 'react-query';

import API from '../../constants/API';
import axios from '../../constants/axios';
import useSimpleLoading from '../useSimpleLoading';

const useLikeDiscussion = (id) => {
  const queryClient = useQueryClient();
  const { onError } = useSimpleLoading();

  const updateLike = () => {
    if (!queryClient.getQueryState(['discussion', `${id}`])) {
      return;
    }
    queryClient.setQueryData(['discussion', `${id}`], (discussion) => {
      return {
        ...discussion,
        isLiked: !discussion.isLiked,
        likeCount: discussion.isLiked
          ? discussion.likeCount - 1
          : discussion.likeCount + 1,
      };
    });
  };

  return useMutation(
    () => {
      return axios.post(API.likeDiscussion, { discussionId: id });
    },
    {
      onError,
      onSuccess: updateLike,
    },
  );
};

export default useLikeDiscussion;
